import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
// MUI
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography
} from "@mui/material";
// models
import { ILoginRequest } from "../../models/auth";
// redux
import { loginWithPassword } from "../../redux/auth/auth.duck";
import InputPassword from "../../components/controls/InputPassword";
import InputForm from "../../components/controls/InputForm";
import { LoginWrapper } from "./styles";
import { ImageCustom } from "../../components";

import LogoIcon from "../../assets/images/login/Logo-Linkco-01.png";
import EmailIcon from "../../assets/images/login/login_icon_email_line_green.svg";
import PasswordIcon from "../../assets/images/login/login_icon_password_line_green.svg";
import Banner from "../../assets/images/login/hinhnen_1.jpg";
import GoogleIcon from "../../assets/images/login/login_logo_google.svg";
import variableStyles from "../../theme/variable-styles";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = (loginInfo: ILoginRequest) => {
    dispatch(loginWithPassword(loginInfo, navigate));
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required(`${"Please enter email"}`),
    password: Yup.string().required(`${"Please enter password"}`)
  }) as any;

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<ILoginRequest>({
    defaultValues: {
      email: null,
      password: null
    },
    resolver: yupResolver(validationSchema)
  });

  return (
    <>
      <Helmet>
        <title>{"Login"}</title>
      </Helmet>
      <LoginWrapper>
        <div className="login-box-left">
          <Link to="/" className="left-logo">
            <ImageCustom
              src={LogoIcon}
              alt="LOGIN_LOGO"
              width={"246px"}
              height={"52px"}
            />
          </Link>
          <h3>Đăng nhập</h3>
          <form onSubmit={handleSubmit(onSubmit)}>
            <InputForm
              placeholder="Email"
              required
              name="email"
              errors={errors}
              control={control}
              startIcon={EmailIcon}
            />
            <InputPassword
              placeholder="Mật khẩu"
              name="password"
              errors={errors}
              control={control}
              startIcon={PasswordIcon}
            />
            <Button
              sx={{ backgroundColor: variableStyles.MainColor }}
              fullWidth
              size="medium"
              type="submit"
              variant="contained"
            >
              Đăng nhập
            </Button>
          </form>
          {/* <Button size="large" variant="text" className="forgot-button">
            Forgot password?
          </Button> */}
          {/* <Divider className="left-divider">or</Divider>
          <Button
            size="medium"
            variant="outlined"
            className="left-google-button"
          >
            <ImageCustom
              src={GoogleIcon}
              alt="Google_Icon"
              width={"24px"}
              height={"24px"}
            />
            Đăng nhập bằng Google
          </Button> */}
          <p
            className="sign-up-question"
            style={{ color: "GrayText", fontWeight: 300 }}
          >
            {`Nếu dăng nhập lần đầu, vui lòng truy cập mail để nhận mật khẩu.\n
              Quên mật khẩu vui lòng liên hệ admin để được cấp lại mật khẩu.`}
          </p>
        </div>
        <div className="login-box-right">
          {/* <ImageCustom
            src={Banner}
            alt="LOGIN_BANNER"
            width={"100%"}
            height={"100%"}
            className="right-banner"
          /> */}
        </div>
      </LoginWrapper>
    </>
  );
};

export default Login;
